import errorStatusMixin from './../mixins/errorStatusMixin'
export default {
  data () {
    return {
      disableButton: false
    }
  },
  methods: {
    takePicture (data) {
      this.showCamera = true
      this.photoType = data
      // Scroll screen to top
      window.scrollTo(0, 0)
      this.addClassToBody()
    },
    addClassToBody () {
      let body = document.body
      body.classList.add('overflowbody')
    },
    removeClassFromBody () {
      let body = document.body
      body.classList.remove('overflowbody')
    },
    takeSignature () {
      this.showSignature = true
      this.addClassToBody()
    },
    closeCamera (data) {
      this.showCamera = false
      this[data[1][0]][data[1][1]] = data[0]
      this.removeClassFromBody()
    },
    closeSignature (data) {
      this.showSignature = false
      this.deliveryInfo.signatures = data[0]
      this.removeClassFromBody()
    },
    showSubmitButton () {
      // Show submit button only if current stand is active or it is job created from tablet
      return (this.activeStand && this.currentStandId === this.activeStand.standId) || this.checkIfJobCreatedFromTablet()
    },
    async standServiceSendData (data) {
      this.disableButton = true
      let isCreatedFromTablet = data.isCreatedFromTablet || false
      let beforePictures = await this.getImagesFromIndexedDb(data.beforePictures)
      let afterPictures = await this.getImagesFromIndexedDb(data.afterPictures)
      let wideAnglePictures = await this.getImagesFromIndexedDb(data.wideAnglePictures)
      let standServiceData = {
        emptyPockets: data.emptyPockets,
        filledPockets: data.filledPockets,
        cleanedStand: data.cleanedStand,
        serviceNotes: data.serviceNotes,
        unableService: data.unableService,
        newDelivered: data.newDelivered,
        headerInstallation: data.headerInstallation,
        outletWithin6Feet: data.outletWithin6Feet,
        canBeRelocated: data.canBeRelocated,
        headerCapable: data.headerCapable
      }
      let standServiceImagesBefore = {
        formType: 'standService',
        images: beforePictures,
        photoType: 0,
        signature: false
      }
      let standServiceImagesAfter = {
        formType: 'standService',
        images: afterPictures,
        photoType: 1,
        signature: false
      }
      let standServiceImagesWideAngle = {
        formType: 'standService',
        images: wideAnglePictures,
        photoType: 2,
        signature: false
      }
      this.sendJobActionData(standServiceData, [standServiceImagesBefore, standServiceImagesAfter, standServiceImagesWideAngle], 1, 'standService', isCreatedFromTablet)
    },
    async eboardServiceSendData (data) {
      this.disableButton = true
      let isCreatedFromTablet = data.isCreatedFromTablet || false
      let pictures = await this.getImagesFromIndexedDb(data.pictures)
      let eboardServiceData = {
        contentDispCorrect: data.contentDispCorrect,
        noBlankScreen: data.noBlankScreen,
        logoMatchesLocation: data.logoMatchesLocation,
        standDisplaced: data.standDisplaced,
        cleanBody: data.cleanBody,
        cleanScreen: data.cleanScreen,
        cleanPlayer: data.cleanPlayer,
        cablesConnectedTightly: data.cablesConnectedTightly,
        reboot: data.reboot,
        pickupsIpAdress: data.pickupsIpAdress,
        mapsDisplayCorrec: data.mapsDisplayCorrec,
        verifyEmailTextWork: data.verifyEmailTextWork,
        standCleaned: data.standCleaned,
        eboardProblem: data.eboardProblem,
        troubleshooting: data.troubleshooting,
        headerInstallation: data.headerInstallation
      }

      let eboardServiceImages = {
        photoType: null,
        formType: 'eboardService',
        images: pictures
      }
      this.sendJobActionData(eboardServiceData, [eboardServiceImages], 2, 'eboardService', isCreatedFromTablet)
    },
    async digitalHeaderServiceSendData (data) {
      console.log('digitalHeaderServiceSendData()')
      this.disableButton = true
      let isCreatedFromTablet = data.isCreatedFromTablet || false
      let pictures = await this.getImagesFromIndexedDb(data.pictures)
      let digitalHeaderServiceData = {
        isScreenWorking: data.isScreenWorking,
        surgeProtectorPlugged: data.surgeProtectorPlugged,
        isSurgeProtector: data.isSurgeProtector,
        surgeProtectorSwitchLit: data.surgeProtectorSwitchLit,
        cordsConnected: data.cordsConnected,
        routerScreenPlugged: data.routerScreenPlugged,
        ethernetCordConnected: data.ethernetCordConnected,
        greenPlugConnected: data.greenPlugConnected,
        routerConnected: data.routerConnected,
        lightsSolid: data.lightsSolid,
        antennasTight: data.antennasTight,
        barsTablet: data.barsTablet,
        ethernetCablePlugged: data.ethernetCablePlugged,
        powerButtonGlowing: data.powerButtonGlowing,
        screenBlack: data.screenBlack,
        screenPurple: data.screenPurple,
        screenPurpleNumbers: data.screenPurple ? data.screenPurpleNumbers : null,
        notes: data.notes
      }

      let digitalHeaderServiceServiceImages = {
        photoType: null,
        formType: 'digitalHeaderService',
        images: pictures
      }
      this.sendJobActionData(digitalHeaderServiceData, [digitalHeaderServiceServiceImages], 2, 'digitalHeaderService', isCreatedFromTablet)
    },
    async digitalHeaderTroubleshootSendData (data) {
      console.log('digitalHeaderTroubleshootSendData()')
      this.disableButton = true
      let isCreatedFromTablet = data.isCreatedFromTablet || false
      let pictures = await this.getImagesFromIndexedDb(data.pictures)
      let digitalHeaderTroubleshootData = {
        isScreenWorking: data.isScreenWorking,
        surgeProtectorPlugged: data.surgeProtectorPlugged,
        isSurgeProtector: data.isSurgeProtector,
        surgeProtectorSwitchLit: data.surgeProtectorSwitchLit,
        cordsConnected: data.cordsConnected,
        routerScreenPlugged: data.routerScreenPlugged,
        ethernetCordConnected: data.ethernetCordConnected,
        greenPlugConnected: data.greenPlugConnected,
        routerConnected: data.routerConnected,
        lightsSolid: data.lightsSolid,
        antennasTight: data.antennasTight,
        barsTablet: data.barsTablet,
        ethernetCablePlugged: data.ethernetCablePlugged,
        powerButtonGlowing: data.powerButtonGlowing,
        screenBlack: data.screenBlack,
        screenPurple: data.screenPurple,
        screenPurpleNumbers: data.screenPurple ? data.screenPurpleNumbers : null,
        notes: data.notes
      }

      let digitalHeaderTroubleshootImages = {
        photoType: null,
        formType: 'digitalHeaderTroubleshoot',
        images: pictures
      }
      this.sendJobActionData(digitalHeaderTroubleshootData, [digitalHeaderTroubleshootImages], 2, 'digitalHeaderTroubleshoot', isCreatedFromTablet)
    },
    async deliveryInfoSendData (data) {
      this.disableButton = true
      let isCreatedFromTablet = data.isCreatedFromTablet || false
      let signatures = await this.getSignaturesFromIndexedDb(data.signatures)
      let deliveryData = {
        deliveryProduct: data.deliveryProduct,
        boxesNumber: data.boxesNumber,
        pickup: data.pickup,
        printedName: data.printedName
      }
      let deliverySignature = {
        images: signatures,
        formType: 'delivery',
        signature: true
      }
      this.sendJobActionData(deliveryData, [deliverySignature], 4, 'delivery', isCreatedFromTablet)
    },
    async tabletServiceSendData (data) {
      this.disableButton = true
      let isCreatedFromTablet = data.isCreatedFromTablet || false
      let pictures = await this.getImagesFromIndexedDb(data.pictures)
      let tabletServiceData = {
        contentDispCorrect: data.contentDispCorrect,
        noBlankScreen: data.noBlankScreen,
        noTypo: data.noTypo,
        plugsSecure: data.plugsSecure,
        notLoose: data.notLoose,
        notTight: data.notTight,
        wiresInconspicuous: data.wiresInconspicuous,
        emailsSet: data.emailsSet,
        mapsLoading: data.mapsLoading,
        contactEttractions: data.contactEttractions,
        cont: data.cont,
        logoMatchesLocation: data.logoMatchesLocation,
        notifyEttraction: data.notifyEttraction,
        tabletCleaned: data.tabletCleaned,
        standCleaned: data.standCleaned,
        surroundAreaCleaned: data.surroundAreaCleaned,
        tabletProblem: data.tabletProblem
      }
      let tabletServiceImages = {
        photoType: null,
        formType: 'tabletService',
        images: pictures
      }
      this.sendJobActionData(tabletServiceData, [tabletServiceImages], 3, 'tabletService', isCreatedFromTablet)
    },
    standInfoSendData (data) {
      this.disableButton = true
      let isCreatedFromTablet = data.isCreatedFromTablet || false
      let standInfoData = {
        standWidth: data.standWidth,
        capableHeader: data.capableHeader,
        standType: data.standType,
        standColor: data.standColor,
        standPockets: data.standPockets
      }
      this.sendJobActionData(standInfoData, [], 5, 'standInfo', isCreatedFromTablet)
    },
    sendJobActionData (dataObj, imagesArray, jobactionType, formType, isCreatedFromTablet) {
      let data = {
        token: this.token,
        jobId: this.activeJob.id,
        formType: formType,
        records: JSON.stringify(dataObj),
        images: this.combaineImages(imagesArray),
        time: this.getCurrentTime()
      }
      // If job has been created from tablet we use this method to send data
      if (this.checkIfJobCreatedFromTablet()) {
        // Add key to separate jobs created in tablet and jobs which we get from server
        data.jobType = isCreatedFromTablet ? 'tablet' : 'server'
        return this.sendCustomJobData(data)
      }
      if (this.activeStand && this.activeStand.standId) {
        data.jobType = 'server'
        data.standId = this.activeStand.standId
      } else {
        data.jobType = 'delivery'
      }
      this.showPreloader = true
      this.$store.dispatch('sendJobAction', data)
        .then(response => {
          if (response) {
            this.showPreloader = false
            this.disableButton = false
            this.showAlert(3, 'Current job action is finished successfully')
            this.resetDataCompleteJobActionGoBack(jobactionType)
          }
        })
        .catch(err => {
          console.log(err)
          this.showPreloader = false
          this.disableButton = false
          if (this.isOffline) {
            this.showAlert(3, 'You are offline now. The data has been save and upload when online')
            this.resetDataCompleteJobActionGoBack(jobactionType)
          }
          if (!this.errorStatusAvaible(err) && this.isOnline) {
            this.resetDataCompleteJobActionGoBack(jobactionType)
            return this.showAlert(4, 'The request timeout exceeded. The data has been saved and uploaded later')
          }
          if (this.isOnline) this.showAlert(5, err.response.data.result.message)
        })
    },
    // This method used to send data when job has been created from tablet
    sendCustomJobData (data) {
      let customCreatedJob = this.$store.state.createdCustomJob
      data.jobId = customCreatedJob.jobId
      data.locId = customCreatedJob.locationId
      data.locNameOrAddress = customCreatedJob.nameAdress
      this.showPreloader = true
      this.disableButton = true
      this.$store.dispatch('sendCustomFormData', data)
        .then(response => {
          this.showPreloader = false
          this.disableButton = false
          this.clearFormData(data.formType)
          this.showAlert(2, 'Custom Job Data has been sent')
          if (!this.checkIfServieFormIsSelected('1') && !this.checkIfServieFormIsSelected('2') && !this.checkIfServieFormIsSelected('4')) {
            this.createJobModal = false
            this.closeCustomJobFormModal()

            if (confirm('Any pirates?')) {
              this.$router.push({ name: 'jobaction', params: { action: '7', customJob: true, location: data.locId } })
            }
          }
        }).catch(err => {
          this.showPreloader = false
          this.disableButton = false
          console.log(err)
          if (!this.errorStatusAvaible(err) && this.isOnline) return this.showAlert(4, 'The request timeout exceeded. The data has been saved and uploaded later')
          if (this.isOnline) this.showAlert(5, err.response.data.result.message)
          if (this.isOffline) {
            this.$router.push({ name: 'jobs' })
          }
        })
    },
    combaineImages (imagesArray) {
      let combainedArr = []
      imagesArray.forEach(imageObj => {
        let images = imageObj.images
        images.forEach(image => {
          let combainedImageObj = {
            photoType: imageObj.photoType,
            signature: imageObj.signature,
            image: image
          }
          combainedArr.push(combainedImageObj)
        })
      })
      return combainedArr
    },
    getImagesFromIndexedDb (imagesIdArray) {
      let imagesArray = []
      return new Promise(resolve => {
        this.$db.images.each(function (item, cursor) {
          if (imagesIdArray.indexOf(item.id) > -1) {
            imagesArray.push(item.canvas)
          }
        }).then(() => {
          resolve(imagesArray.slice())
          console.log('Ok')
        })
          .catch(err => {
            this.showAlert(2, 'Problem with getting images from db. Please reload the app')
            console.log(err)
          })
      })
    },
    getSignaturesFromIndexedDb (signaturesIdArray) {
      let signaturesArray = []
      return new Promise(resolve => {
        this.$db.signatures.each(function (item, cursor) {
          if (signaturesIdArray.indexOf(item.id) > -1) {
            signaturesArray.push(item.canvas)
          }
        }).then((data) => {
          resolve(signaturesArray.slice())
        })
      })
    },
    resetDataCompleteJobActionGoBack (jobactionType) {
      this.completeJobAction(jobactionType)
      this.resetFormData(jobactionType)
      this.goBack()
    },
    goBack () {
      let currentJob = this.$store.state.currentJob
      if (!currentJob) return this.$router.push({ path: '/' })
      this.$router.push({ name: 'job', params: { id: currentJob } })
    },
    goToJobs (resetActiveStand) {
      let currentJob = this.$store.state.currentJob

      if (resetActiveStand && this.activeStand) this.activeStand.isActive = false

      if (!currentJob) return this.$router.push({ path: '/jobs' })
      this.$router.push({ name: 'job', params: { id: currentJob } })
    },
    completeJobAction (jobActionType) {
      let activeStandId = this.activeStand.standId
      let activeJobId = this.$store.state.activeJob.id
      this.$store.commit('completeJobAction', { jobActionType, activeStandId, activeJobId })
    },
    resetFormData (jobactionType) {
      switch (jobactionType) {
        case 1:
          this.clearFormData('standService')
          break
        case 2:
          this.clearFormData('eboardService')
          break
        case 3:
          this.clearFormData('tabletService')
          break
        case 4:
          this.clearFormData('deliveryInfo')
          break
        case 5:
          this.clearFormData('standInfo')
          break
        case 8:
          this.clearFormData('digitalHeaderService')
          break
        case 9:
          this.clearFormData('digitalHeaderTroubleshoot')
          break
      }
    },
    clearFormData (dataObj) {
      let objData = this[dataObj]
      for (var key in objData) {
        if (Array.isArray(objData[key])) {
          objData[key] = []
        } else {
          objData[key] = null
        }
      }
    }
  },
  mixins: [errorStatusMixin]
}
